import { Field as BaseField } from "react-final-form";
import { isValidElement, cloneElement, useMemo } from "react";
import { nanoid } from "nanoid";
import FieldControl from "../../components/field-control";
import { isFunction, isDefined } from "../../utils/type-util";
import { pick } from "../../utils/object-util";
import { spacePropNames } from "../../utils/style-util";
import { jsx as _jsx } from "react/jsx-runtime";
const emptyArray = [];
function getInputType(element) {
  if (element.type.name === "Checkbox" || element.type.name === "Switch") {
    return "checkbox";
  }
  if (element.type.name === "RadioGroup" || element.type.name === "VisualPicker") {
    return "text";
  }
  return undefined;
}
function getInitialValue(element) {
  if (element.type.name === "CheckboxGroup") {
    return emptyArray;
  }
  if (element.type.name === "VisualPicker" && element.props.multiple) {
    return emptyArray;
  }
  if (element.type.name === "Select" && ["multiple", "tags"].includes(element.props.mode)) {
    return emptyArray;
  }
  return undefined;
}
function getErrorVisible(showError, meta) {
  if (isFunction(showError)) {
    return !!showError(meta);
  }
  if (isDefined(showError)) {
    return !!showError;
  }
  return meta.touched;
}
function composeHandlers() {
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  const handleEvent = name => function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    sources.forEach(source => {
      if (isFunction(source[name])) {
        source[name](...args);
      }
    });
  };
  return {
    onChange: handleEvent("onChange"),
    onFocus: handleEvent("onFocus"),
    onBlur: handleEvent("onBlur")
  };
}
function Field(_ref) {
  let {
    id,
    label,
    extra,
    inline,
    adminOnly,
    showError,
    showHelp,
    className,
    style,
    children,
    ...rest
  } = _ref;
  // TODO replace with useId in react 18
  const fieldId = useMemo(() => id ?? nanoid(8), []);
  if ( /*#__PURE__*/isValidElement(children)) {
    const type = getInputType(children);
    const initialValue = getInitialValue(children);
    const spaceProps = pick(rest, spacePropNames);
    return /*#__PURE__*/_jsx(BaseField, {
      type: type,
      initialValue: initialValue,
      ...rest,
      children: _ref2 => {
        let {
          input,
          meta
        } = _ref2;
        const errorVisible = getErrorVisible(showError, meta);
        return /*#__PURE__*/_jsx(FieldControl, {
          htmlFor: fieldId,
          label: label,
          extra: extra,
          inline: inline,
          adminOnly: adminOnly,
          className: className,
          style: style,
          validateStatus: meta.error && errorVisible ? "error" : "default",
          help: meta.error && errorVisible ? meta.error : "",
          showHelp: showHelp,
          ...spaceProps,
          children: /*#__PURE__*/cloneElement(children, {
            id: fieldId,
            ...input,
            ...composeHandlers(input, children.props)
          })
        });
      }
    });
  }
  return /*#__PURE__*/_jsx(BaseField, {
    ...rest,
    children: children
  });
}
Field.Control = FieldControl;
export default Field;